const IcSort = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.99977 3.40083L8.84893 5.25L9.67143 4.4275L6.99977 1.75L4.32227 4.4275L5.1506 5.25L6.99977 3.40083ZM6.99977 10.5992L5.1506 8.75L4.3281 9.5725L6.99977 12.25L9.67727 9.5725L8.84893 8.75L6.99977 10.5992Z" />
  </svg>
)
export default IcSort
